import { Button, Modal,message,Row,Col, Spin} from 'antd';
import isEmpty from 'lodash/isEmpty'
import debounce from 'lodash/debounce'
import cloneDeep from 'lodash/cloneDeep'
import toString from 'lodash/toString'
import forEach from 'lodash/forEach'
import { WeaErrorPage, WeaTools,WeaTableEdit,WeaSearchGroup,WeaRightMenu, WeaFormItem, WeaTab} from 'ecCom'
import {WeaSwitch} from 'comsMobx';
import { inject, observer} from 'mobx-react';
import * as mobx from 'mobx';
import {i18n} from '../../public/i18n';
const toJS = mobx.toJS;

@inject('hrmPersonal')
@inject('hrmCard')
@observer
class Personal extends React.Component {
  constructor(props) {
    super(props);
    const funcs = ['tableEditChange', 'editCard','backCard','saveEditCard', 'onTabChange'];
    funcs.forEach(f=> this[f] = this[f].bind(this))
  }
  componentDidMount(){
    const {hrmCard} = this.props;
    hrmCard.setTopButtons(this.getTopButtons.bind(this));
    hrmCard.setTopRightMenus(this.getRightMenu.bind(this));
    hrmCard.setTopShowDropIcon(true);
    this.init();
  }
  init() {
    const {hrmPersonal} = this.props;
    const hrmId = this.props.params.hrmId || '';
    hrmPersonal.init();
    hrmPersonal.hrmId=hrmId;
    hrmPersonal.getData();
  }
  getTabChildren(){
    const {hrmPersonal} = this.props;
    let {tableInfo, isEditor, tabkey} = hrmPersonal;
    let tabChildren = [];
    tableInfo = toJS(tableInfo);
    tableInfo && tableInfo.map((t,i)=>{
        if(tabkey==i){
          if(t.hide){

          }else{
            tabChildren.push(
              <WeaTableEdit
                  ref={(ref)=>hrmPersonal.setPersonalEditTables(ref)}
                  showTitle={isEditor}
                  // title={'列表信息'}
                  addFirstRow={isEditor}
                  columns={t.tabinfo.columns}
                  datas={t.tabinfo.datas}
                  onChange={this.tableEditChange}
                  viewAttr={isEditor?2: 1}
                  getRowSelection={isEditor? null: ()=>null}
              />
            );
          }
        }
    })
    return tabChildren;
  }
  getSearchs(){
    const {hrmPersonal} = this.props;
    let {form, conditions, isEditor} = hrmPersonal;
    const {isFormInit} = form;
    let group = [];
    let tipPosition = 'bottom';
    conditions = toJS(conditions);
    window.e9HideFormFieldKeys = [];
    isFormInit && conditions.forEach(c =>{
        let items = [];
        c.items.forEach( field => {
          if(c.hide || (!isEmpty(field.otherParams) && field.otherParams.hide)){
            window.e9HideFormFieldKeys.push(field.domkey[0]);
          }else{
            items.push({
                com:(<WeaFormItem
                    underline={!isEditor}
                    label={`${field.label}`}
                    error={form.getError(field)}
                    tipPosition={tipPosition}
                    labelCol={{span: `${window.HrmLabelCol}`}}
                    wrapperCol={{span: `${window.HrmWrapperCol}`}}>
                      <WeaSwitch fieldConfig={field} form={form}/>
                    </WeaFormItem>),
                colSpan: 1
              });
          }
        });
        group.push(<WeaSearchGroup className={`${isEditor?'hrm-center':''}`}
          needTigger={true} hide={c.hide} title={c.title} showGroup={c.defaultshow} items={items} col={window.HrmGroupCol}/>)
    });
    return group;
  }
  tableEditChange(data){
    const {hrmPersonal} = this.props;
    let {tabkey = '0', tableInfo} = hrmPersonal;
    tableInfo = toJS(tableInfo);
    let d = cloneDeep(tableInfo);
    d[Number(tabkey)].tabinfo.datas = data;
    hrmPersonal.updateTableInfo(d);
  }
  onTabChange(key) {
    const {hrmPersonal} = this.props;
    hrmPersonal.changeTab(key);
  }
  getRightMenu(){
    const {hrmPersonal, hrmCard} = this.props;
    const {isEditor, buttons,hrmId} = hrmPersonal;
    let arr = [];
    if(buttons.hasEdit){
        if (isEditor){
            arr = [{
                icon: <i className='icon-coms-common'/>,
                content: i18n.button.save(),
                key: 'save',
                onClick: key =>{
                  this.saveEditCard();
                }
              }, {
                icon: <i className='icon-coms-go-back'/>,
                content: i18n.button.back(),
                key: 'back',
                onClick: key =>{
                  this.backCard();
                }
              }]
        } else {
            arr = [{
                    icon: <i className='icon-coms-edit'/>,
                    content:i18n.button.modify(),
                    key: 'editCard',
                    onClick: key =>{
                        this.editCard();
                    }
                }
            ]

            arr.push(
              {
                icon: <i className='icon-coms-Print-log'/>,
                content:i18n.button.log(),
                key: 'showLog',
                onClick: key =>{
                  window.setLogViewProps({logSmallType:i18n.smallType.HRM_RSOURCE_CARD_PERSONAL,targetId:hrmId});
                }
              }
            )
        }
    }
    return arr;
  }
  
  getTopButtons() {
    const {hrmPersonal} = this.props;
    const {isEditor, buttons} = hrmPersonal;
    const save = <Button type="primary" onClick={this.saveEditCard} >{i18n.button.save()}</Button>;
    const back = <Button type="primary" onClick={this.backCard} >{i18n.button.back()}</Button>;
    const edit = <Button type="primary" onClick={this.editCard} >{i18n.button.modify()}</Button>;
    const btns = [];
    if (isEditor) {
      if (buttons.hasSave) {
        btns.push(save);
        btns.push(back);
      }
    } else {
      if (buttons.hasEdit) {
        btns.push(edit);
      }
    }
    return btns;
  }
  editCard(){
    const {hrmPersonal} = this.props;
    hrmPersonal.edit();
  }
  saveEditCard(){
    const {hrmPersonal} = this.props;
    hrmPersonal.save();
  }
  backCard(){
    this.init();
  }
  render() {
    const {hrmPersonal} = this.props;
    const {loading, tabkey, tabInfo, date, tableInfo} = hrmPersonal;
    //let showDetialTable = !isEmpty(tableInfo.filter(t => !t.hide));
    return  (
        <div className='hrm-my-cardInfo' style={{height:'100%', position: 'relative'}}>
            <Spin spinning={loading}>
                <WeaRightMenu
                    datas={this.getRightMenu()}
                    onClick={this.onRightMenuClick}
                >
                    {this.getSearchs()}
                    {
                      !isEmpty(tabInfo) && <div className='hrm-my-cardInfo_detial_tabs'>
                      <WeaTab
                          type='card'
                          keyParam='key'
                          datas={toJS(tabInfo)}
                          selectedKey={tabkey}
                          onChange={ v => {
                              hrmPersonal.updateTabkey(v);
                          }}
                      />
                      {this.getTabChildren()}
                     </div>
                    }
                    
                </WeaRightMenu>
            </Spin>
        </div>
    )
  }
}

export default Personal;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/card/Personal.js